import { createSelector } from '@reduxjs/toolkit';
import { selectApp } from './selectApp';

/** Select flag that indicates that template was selected and loaded */
export const selectIsTemplateLoaded = createSelector([selectApp], (state) => !!state.template);
